<header id="page-topbar">
  <div class="navbar-header p-2 text-center">
    <div class="d-flex flex-row justify-content-center align-items-center gap-3 flex-nowrap px-3">
      <img id="clientLogo" [src]="getLogoPath('')" alt="ADAPTIS Tap to Pay" class="img-fluid" style="height: 5.875rem; width: auto; max-width: 45%;">
      @if (clientId !== 'ttpoi-web') {
        <span class="vr header-separator"></span>
        <img id="{{clientId}}Logo" [src]="getLogoPath(clientId)" alt="ADAPTIS Tap to Pay with {{clientId}}" class="img-fluid" style="height: 5.875rem; width: auto; max-width: 45%;">
      }
    </div>
  </div>
</header>
